<div
  class="gamification-cards"
  [ngClass]="{ 'gamification-cards-column': isDrawerOpen }"
>
  <div class="gamification-card" *ngIf="trendingConsumers[activeCategoryForConsumers - 1] && userId == 4">
    <div class="gamification-card-header">
      <div class="gamification-card-title">
        <p>
          Top 3 Users of the week for
          {{ trendingConsumers[activeCategoryForConsumers - 1].category_name }}
        </p>
      </div>
      <div class="action-buttons">
        <img
          src="assets\icons\chevron-backward.svg" alt=""
          alt="backword-arrow"
          (click)="decrementCategory()"
        />
        <p>
          {{ activeCategoryForConsumers }}/{{ numberOfCategoriesForConsumers }}
        </p>
        <img
          src="assets\icons\chevron-forward-active.svg" alt=""
          alt="forword-arrow"
          (click)="incrementCategory()"
        />
      </div>
    </div>
    <div class="gamification-card-body">
      <div
        class="rank-card"
        *ngFor="
          let consumer of trendingConsumers[activeCategoryForConsumers - 1]
            .consumers;
          let i = index
        "
      >
        <div [class]="'rank-card-header rank-' + (i + 1) + '-card-header'">
          <div class="rank-card-title">Rank {{ i + 1 }}</div>
          <div [class]="'rank-' + (i + 1) + '-img'">
            <img
              [src]="'assets/icons/rank-' + (i + 1) + '.svg'"
              alt="frame-medal"
            />
          </div>
        </div>
        <div class="rank-card-contant">
          <div class="profile-image">
            <img src="/assets/icons/merck_profile_default.svg" alt="avatar" />
            <img
              class="crown"
              [src]="'/assets/icons/crown-' + (i + 1) + '.svg'"
              alt="crown"
            />
          </div>
          <div class="profile-content">
            <div class="profile-name">
              {{ consumer.firstname }} {{ consumer.lastname }}
            </div>
            <div class="profile-information">
              <div class="prompts-and-ratings">
                <div class="prompts">
                  <img src="/assets/icons/terminal.svg" alt="terminal" />
                  <p>{{ consumer.execution_count }} Prompts used</p>
                </div>
                <div class="ratings">
                  <img src="assets/icons/execution-profile.svg" alt="profile star" />
                  <p class="average-rating">
                    {{ consumer.average_rating }} Ratings
                  </p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="gamification-card" *ngIf="trendingCreators[activeCategoryForCreators - 1] && userId == 3">
    <div class="gamification-card-header">
      <div class="gamification-card-title">
        <p>
          Top 3 Creators of the week for
          {{ trendingCreators[activeCategoryForCreators - 1].category_name }}
        </p>
      </div>
      <div class="action-buttons">
        <img
          src="assets\icons\chevron-backward.svg" alt=""
          alt="backword-arrow"
          (click)="decrementCategory()"
        />
        <p>
          {{ activeCategoryForCreators }}/{{ numberOfCategoriesForCreators }}
        </p>
        <img
          src="assets\icons\chevron-forward-active.svg" alt=""
          alt="forword-arrow"
          (click)="incrementCategory()"
        />
      </div>
    </div>
    <div class="gamification-card-body">
      <div
        class="rank-card"
        *ngFor="
          let creator of trendingCreators[activeCategoryForCreators - 1]
            .creators;
          let i = index
        "
      >
        <div [class]="'rank-card-header rank-' + (i + 1) + '-card-header'">
          <div class="rank-card-title">Rank {{ i + 1 }}</div>
          <div [class]="'rank-' + (i + 1) + '-img'">
            <img
              [src]="'assets/icons/rank-' + (i + 1) + '.svg'"
              alt="frame-medal"
            />
          </div>
        </div>
        <div class="rank-card-contant">
          <div class="profile-image">
            <img src="/assets/icons/merck_profile_default.svg" alt="avatar" />
            <img
              class="crown"
              [src]="'/assets/icons/crown-' + (i + 1) + '.svg'"
              alt="crown"
            />
          </div>
          <div class="profile-content">
            <div class="profile-name">
              {{ creator.firstname }} {{ creator.lastname }}
            </div>
            <div class="profile-information">
              <div class="prompts-and-ratings">
                <div class="prompts">
                  <img src="/assets/icons/terminal.svg" alt="terminal" />
                  <p>{{ creator.created_count }} Prompts</p>
                </div>
                <div class="ratings">
                  <img src="assets/icons/gold_star_half.svg" alt="half star" />
                  <p class="average-rating">
                    {{ creator.average_rating }}
                  </p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="gamification-card" *ngIf="trendingCurators[activeCategoryForCurators - 1] && userId == 2">
    <div class="gamification-card-header">
      <div class="gamification-card-title">
        <p>
          Top 3 Approvers of the week for
          {{ trendingCurators[activeCategoryForCurators - 1].category_name }}
        </p>
      </div>
      <div class="action-buttons">
        <img
          src="assets\icons\chevron-backward.svg" alt=""
          alt="backword-arrow"
          (click)="decrementCategory()"
        />
        <p>
          {{ activeCategoryForCurators }}/{{ numberOfCategoriesForCurators }}
        </p>
        <img
          src="assets\icons\chevron-forward-active.svg" alt=""
          alt="forword-arrow"
          (click)="incrementCategory()"
        />
      </div>
    </div>
    <div class="gamification-card-body">
      <div
        class="rank-card"
        *ngFor="
          let curator of trendingCurators[activeCategoryForCurators - 1]
            .curators;
          let i = index
        "
      >
        <div [class]="'rank-card-header rank-' + (i + 1) + '-card-header'">
          <div class="rank-card-title">Rank {{ i + 1 }}</div>
          <div [class]="'rank-' + (i + 1) + '-img'">
            <img
              [src]="'assets/icons/rank-' + (i + 1) + '.svg'"
              alt="frame-medal"
            />
          </div>
        </div>
        <div class="rank-card-contant">
          <div class="profile-image">
            <img src="/assets/icons/merck_profile_default.svg" alt="avatar" />
            <img
              class="crown"
              [src]="'/assets/icons/crown-' + (i + 1) + '.svg'"
              alt="crown"
            />
          </div>
          <div class="profile-content">
            <div class="profile-name">
              {{ curator.firstname }} {{ curator.lastname }}
            </div>
            <div class="profile-information">
              <div class="prompts-and-ratings">
                <div class="prompts">
                  <img src="/assets/icons/terminal.svg" alt="terminal" />
                  <p>{{ curator.approval_count }} Prompts reviewed</p>
                </div>
                <div class="ratings">
                  <img src="assets/icons/gold_star_half.svg" alt="half star" />
                  <p class="average-rating">
                    {{ curator.average_rating }}
                  </p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="gamification-card" *ngIf="trendingPrompts[activeCategoryForPrompts - 1]">
    <div class="gamification-card-header">
      <div class="gamification-card-title">
        <p>
          Top 5 Trending Prompts of the week for
          {{ trendingPrompts[activeCategoryForPrompts - 1].category_name }}
        </p>
      </div>
      <div class="action-buttons">
        <img
          src="assets\icons\chevron-backward.svg" alt=""
          alt="backword-arrow"
          (click)="decrementCategory('prompts')"
        />
        <p>{{ activeCategoryForPrompts }}/{{ numberOfCategoriesForPrompts }}</p>
        <img
          src="assets\icons\chevron-forward-active.svg" alt=""
          alt="forword-arrow"
          (click)="incrementCategory('prompts')"
        />
      </div>
    </div>
    <div class="gamification-card-body">
      <div
        class="prompt-card"
        *ngFor="
          let prompt of trendingPrompts[activeCategoryForPrompts - 1].prompts
        "
      >
        <div class="prompt-card-title">{{ prompt.title }}</div>
        <p class="prompt-card-date">
          Published on: <strong>{{
            formatDate(prompt.created_datetime)
          }}</strong>
        </p>
        <div class="prompt-card-data">
          <div class="prompt-card-data-section">
            <img src="assets/icons/execution-count.svg" alt="play" />
            <p>{{ prompt.total_views }}</p>
          </div>
          <div class="prompt-card-data-section">
            <img src="assets/icons/star_half.svg" alt="star rating" />
            <p>{{ prompt.average_rating }}</p>
          </div>
          <div class="prompt-card-data-section">
            <img src="assets/icons/execution-profile.svg" alt="profile star" />
            <p>{{ prompt.total_feedbacks }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
